const modal = {
  root: {
    background: '{white}',
    borderRadius: '{border.radius.l}',
    shadow: '0px 0px 6px 0px rgba(0,0,0,.2)',
    padding: '{spacing.m}',
    footer: {
      gap: '4px',
    },
  },
  screen: {
    default: {
      padding: '{spacing.xl}',
    },
    small: {
      padding: '1.5rem',
    },
  },
  content: {
    padding: '{spacing.m}',
  },
  mask: {
    background: 'rgba(0,0,0,.5)',
  },
  header: {
    padding: '',
  },
  closeButton: {
    padding: '{spacing.xxs} 0 0 0',
    background: 'transparent',
    modal: {
      padding: '0',
      top: '6px',
      right: '6px',
    },
  },
  actionSheet: {
    margin: '0',
    padding: '{spacing.s}',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
  },
  css: () => `
  .p-dialog.sb-ds-modal {
    $p: &;
    padding: var(--p-dialog-screen-default-padding);
    position: relative;
    width: auto;

    @media only screen and (max-width: 768px) {
      padding: var(--p-dialog-screen-small-padding);
      width: 100%;
    }
  }

  .p-dialog.sb-ds-modal-fullscreen {
    height: 100%;
		max-height: 100%;
		width: 100%;
  }

  .p-dialog.sb-ds-modal-action-sheet {
    border-bottom-left-radius: var(--p-dialog-action-sheet-border-bottom-left-radius);
		border-bottom-right-radius: var(--p-dialog-action-sheet-border-bottom-right-radius);
		margin: var(--p-dialog-action-sheet-margin);
		padding: var(--p-dialog-action-sheet-padding);
  }

  .p-dialog-content.sb-ds-modal-content {
    padding: 0;
  }
  
  .p-dialog-header.sb-ds-modal-header {
    display: flex;
		justify-content: flex-end;
		padding: 0;
		position: absolute;
		right: 0;
		top: 0;
		width: 100%;
  }

  .p-dialog-mask.sb-ds-modal-mask {
    background: var(--p-dialog-mask-background);
		padding: var(--p-dialog-padding);
  }
  
  .p-dialog-mask.sb-ds-modal-mask-absolute {
    position: absolute;
  }

  .p-dialog-mask.sb-ds-modal-mask-no-padding {
    background: transparent;
    padding: 0;
  }

  .p-dialog-close-button.sb-ds-modal-close-button {
    background: var(--p-dialog-close-button-background);
		border: unset;
		padding: var(--p-dialog-close-button-modal-padding);
		right: var(--p-dialog-close-button-modal-right);
		top: var(--p-dialog-close-button-modal-top);
		width: auto;
		
		&:hover {
			border: unset !important;
      background: var(--p-dialog-close-button-background) !important;
		}
  }

  .sb-ds-modal-loading-wrapper {
    position: relative;
  }
`,
};

export default modal;
